exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1hD5LDIS-MainContainer-module-with-room-for-header{padding-top:75px}._1o_0E6mZ-MainContainer-module-without-room-for-header{padding-top:0}", ""]);

// exports
exports.locals = {
	"with-room-for-header": "_1hD5LDIS-MainContainer-module-with-room-for-header",
	"withRoomForHeader": "_1hD5LDIS-MainContainer-module-with-room-for-header",
	"without-room-for-header": "_1o_0E6mZ-MainContainer-module-without-room-for-header",
	"withoutRoomForHeader": "_1o_0E6mZ-MainContainer-module-without-room-for-header"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"localIdentName":"[hash:base64:8]-[name]-[local]","modules":true,"camelCase":true}!../~/postcss-loader/lib!../~/sass-loader/lib/loader.js!./js/components/support/layout/MainContainer/MainContainer.module.scss
// module id = 756
// module chunks = 0